import React from 'react';
import { Link } from 'react-router-dom';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import ShieldIcon from '@mui/icons-material/Shield';
import InsightsIcon from '@mui/icons-material/Insights';
import FlashOnIcon from '@mui/icons-material/FlashOn';
import Button from '../../utils/Button';

const MessagingSetupSuccess: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-sky-50 flex items-center justify-center px-4 py-10">
      <div className="max-w-7xl w-full grid lg:grid-cols-3 gap-6">
        {/* Left: Confirmation Card */}
        <div className="lg:col-span-2 bg-white/80 backdrop-blur shadow-xl rounded-3xl border border-slate-100 overflow-hidden">
          <div className="relative px-8 pt-10 pb-6">
            <div className="absolute inset-x-10 top-0 h-1 bg-gradient-to-r from-sky-500 via-cyan-400 to-emerald-400 rounded-b-full" />
            <div className="flex items-center gap-3">
              <div className="h-12 w-12 rounded-2xl bg-sky-100 text-sky-600 flex items-center justify-center">
                <CheckCircleIcon fontSize="large" />
              </div>
              <div>
                <p className="text-xs uppercase tracking-[0.2em] text-slate-500">Payment Confirmed</p>
                <h1 className="text-2xl md:text-3xl font-bold text-slate-900">Messaging Setup Fee Received</h1>
              </div>
            </div>

            <div className="mt-6 grid sm:grid-cols-2 gap-4">
              <div className="p-4 rounded-2xl bg-slate-50 border border-slate-100">
                <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide">Amount</p>
                <p className="text-3xl font-bold text-slate-900">$15.00 USD</p>
                <p className="text-sm text-slate-600 mt-1">One-time Shared Messaging setup fee</p>
              </div>
              <div className="p-4 rounded-2xl bg-gradient-to-r from-sky-500 to-cyan-500 text-white shadow-lg">
                <p className="text-xs font-semibold uppercase tracking-wide text-white/80">Status</p>
                <p className="text-2xl font-bold">Unlocked</p>
                <p className="text-sm text-white/90 mt-1">Messaging features are now enabled for your team.</p>
              </div>
            </div>

            <div className="mt-8">
              <h2 className="text-lg font-semibold text-slate-900 mb-3">You now have access to</h2>
              <div className="">
                <FeatureItem
                  icon={<LocalPhoneIcon fontSize="small" />}
                  title="10DLC Messaging"
                  description="Registered long-code messaging ready for campaigns."
                />
                <FeatureItem
                  icon={<ShieldIcon fontSize="small" />}
                  title="Compliance Handling"
                  description="Carrier & FCC alignment with opt-in/opt-out flows."
                />
                <FeatureItem
                  icon={<InsightsIcon fontSize="small" />}
                  title="Billing & Usage Insights"
                  description="Live visibility into message volume, costs, and fees."
                />
                <FeatureItem
                  icon={<FlashOnIcon fontSize="small" />}
                  title="Priority Support"
                  description="Fast-track assistance for campaign reviews and launches."
                />
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row gap-3 w-full">
              <Link to="/partner/settings">
                <Button variant="primary" size="large" label="Go to Messaging Settings" additionalClassname="" />
              </Link>
              <Link to="/partner/dashboard">
                <Button variant="secondary" size="large" label="Back to Dashboard" additionalClassname="" />
              </Link>
            </div>
          </div>
        </div>


      </div>
    </div>
  );
};

type FeatureItemProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
};

const FeatureItem: React.FC<FeatureItemProps> = ({ icon, title, description }) => (
  <div className="flex items-start gap-3 p-3 rounded-2xl border border-slate-100 bg-white hover:border-sky-100 hover:shadow-sm transition">
    <div className="mt-1 h-9 w-9 rounded-xl bg-sky-50 text-sky-600 flex items-center justify-center">
      {icon}
    </div>
    <div>
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <p className="text-sm text-slate-600">{description}</p>
    </div>
  </div>
);

type StepItemProps = {
  title: string;
  detail: string;
};

const StepItem: React.FC<StepItemProps> = ({ title, detail }) => (
  <li className="flex gap-3">
    <div className="mt-1 h-2 w-2 rounded-full bg-sky-500" />
    <div>
      <p className="text-sm font-semibold text-slate-900">{title}</p>
      <p className="text-sm text-slate-600">{detail}</p>
    </div>
  </li>
);

export default MessagingSetupSuccess;
